module.exports = __webpack_public_path__ + "static/media/chevron-right.d9eee689.svg";